import { Injectable } from '@angular/core';
import { GeralApi } from '@gestor-web/@core/api/ords';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ProcedimentosElegiveisService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getData(regans: string, competenciaInicial: string, competenciaFinal: string) {
    const dados$ = this.simuladorGoApi.fetchProcedimentosElegiveis({
      regans,
      competencia: competenciaInicial,
      competencia_final: competenciaFinal,
    });

    return combineLatest([this.simuladorGoApi.fetchClassesProcedimentos({ regans }), dados$]).pipe(
      map(([classes, dados]) => {
        const dadosReais =
          dados.items
            ?.filter(item => item.ds_classe !== 'Consulta em pronto-socorro')
            .map(item => ({
              ...item,
              qt_item: item.qt_item == null ? 0 : item.qt_item,
            })) || [];

        const competenciasExistentes = [...new Set(dadosReais.map(item => item.nr_competencia))];

        const classesComDados = new Set(dadosReais.map(item => item.ds_classe));

        const classesSemDados =
          classes.items?.filter(
            classe => classe.ds_classe !== 'Consulta em pronto-socorro' && !classesComDados.has(classe.ds_classe),
          ) || [];

        const tabelaTuss = dadosReais.length > 0 ? dadosReais[0].cd_tabela_tuss : 'Tabela não informada';

        const chaveCombinacao = (item: any) =>
          `${item.ds_classe || ''}||${item.cd_classe || ''}||${item.cd_proced_item || ''}||${item.cd_tabela_tuss || tabelaTuss}`;

        const combinacoes = new Map<string, any>();
        const combinacaoCompetencia = new Set<string>();

        for (const item of dadosReais) {
          const comboKey = chaveCombinacao(item);

          if (!combinacoes.has(comboKey)) {
            combinacoes.set(comboKey, {
              ds_classe: item.ds_classe,
              cd_classe: item.cd_classe,
              cd_proced_item: item.cd_proced_item,
              nm_proced_item: item.nm_proced_item,
              cd_tabela_tuss: item.cd_tabela_tuss || tabelaTuss,
            });
          }

          combinacaoCompetencia.add(`${comboKey}||${item.nr_competencia}`);
        }

        // Completa buracos por competência para as combinações existentes, evitando células vazias no pivot.
        const dadosCompletados = [...dadosReais];
        for (const [, combo] of combinacoes) {
          for (const competencia of competenciasExistentes) {
            const comboKey = `${chaveCombinacao(combo)}||${competencia}`;
            if (!combinacaoCompetencia.has(comboKey)) {
              dadosCompletados.push({
                nr_competencia: competencia,
                ds_classe: combo.ds_classe,
                cd_classe: combo.cd_classe,
                cd_proced_item: combo.cd_proced_item,
                nm_proced_item: combo.nm_proced_item,
                cd_tabela_tuss: combo.cd_tabela_tuss,
                qt_item: 0,
              });
            }
          }
        }

        const dadosFake = [];
        for (const classe of classesSemDados) {
          for (const competencia of competenciasExistentes) {
            dadosFake.push({
              nr_competencia: competencia,
              ds_classe: classe.ds_classe,
              qt_item: 0,
              cd_tabela_tuss: tabelaTuss,
            });
          }
        }

        return [...dadosCompletados, ...dadosFake];
      }),
    );
  }

  getUltimoProcessamento(regans: string) {
    return this.simuladorGoApi.fetchUltimoProcessamento({ regans });
  }
}
